export const generativeAiAgentsCanvasQa = "/:app_group_id/generative_ai/agents/canvas_qa";
